<template>
  <div class="app-container">
    <Header></Header>
    <div class="top">
      <div class="title">精彩视频</div>
    </div>
    <div class="video-list">
      <div class="video-content">
        <div class="video-item" v-for="(item, index) in videos" :key="index">
          <div class="cover">
            <img
              :src="
                $store.state.isMobile
                  ? item.showImagesRealPath[0]
                  : item.showImagesRealPath[1]
              "
              alt=""
            />
            <img
              class="play"
              src="@/assets/images/videos/play.png"
              alt=""
              @click="didClick_selVideo(item)"
            />
          </div>
          <div class="content">
            <div class="title ellipsis-2">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <video-player
      v-if="selectVideo"
      :propsData="{ ...nowVideo }"
      @changeSelectVideo="changeSelectVideo"
    ></video-player>
    <suspension></suspension>
    <cook-tip></cook-tip>
    <foot></foot>
  </div>
</template>

<script>
import Header from "../components/Header";
import Foot from "../components/Foot";
import VideoPlayer from "../components/common/VideoPlayer";
import CookTip from "../components/CookTip";
import { staticApi } from "../services";
import Suspension from "../components/Suspension";

export default {
  name: "news",
  data() {
    return {
      videos: [],
      nowVideo: null,
      selectVideo: false,
    };
  },
  components: {
    Header,
    Foot,
    VideoPlayer,
    CookTip,
    Suspension,
  },
  computed: {},
  created() {
    this.getVideosList();
  },
  methods: {
    //获取精彩视频列表
    getVideosList() {
      staticApi
        .request(
          `/${this.$config.tenantId}/seminar/${this.$config.seminarId}/article/list/${this.$config.videosId}.json`
        )
        .then((res) => {
          if (res.result === 0) {
            const videos = res.content.items;
            for (const item of videos) {
              if (item.showImagesRealPath.length == 1) {
                item.showImagesRealPath[1] = item.showImagesRealPath[0];
              }
              if (item.showImagesRealPath[0]) {
                item.showImagesRealPath[0] = item.showImagesRealPath[0].replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
              }
              if (item.showImagesRealPath[1]) {
                item.showImagesRealPath[1] = item.showImagesRealPath[1].replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
              }
            }
            //排序
            videos.sort((a, b) => {
              return a.pushTime - b.pushTime;
            });
            //位置排序
            videos.sort((a, b) => {
              return b.order - a.order;
            });
            this.videos = videos;
            this.nowVideo = videos[0];
          }
        })
        .catch((err) => {
          console.error("获取列表失败", err);
        });
    },
    //点击视频
    didClick_selVideo(option) {
      window._hw("send", "action", "video_page_video_play_click", {
        video_name: option.title, // 内容名称
        product_tag: option.tags[0] ? option.tags[0].name : "", //产品标签
        industry_tag: option.tags[1] ? option.tags[1].name : "", //行业标签
        solution_tag: option.tags[2] ? option.tags[2].name : "", //解决方案标签
        hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系
      });
      this.nowVideo = option;
      this.selectVideo = true;
      //完成任务
      this.$store.dispatch("interaction/onCompleteTask", {
        desc: "精彩瞬间",
        objectId: option.id,
      });
    },
    //关闭播放器
    changeSelectVideo() {
      this.selectVideo = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 992px) {
  @import "./css/videos/pc.scss";
}
@media screen and (max-width: 992px) {
  @import "./css/videos/wap.scss";
}
</style>
